import type { ReactElement } from 'react'
import { useTranslation } from '@front/model'
import { TButton, type TButtonProps } from './button'

type Props = TButtonProps & {
  refetch: VoidFunction
  isFetching?: boolean
}

export const ButtonRefresh = ({ refetch, isFetching, ...props }: Props): ReactElement => {
  const { t } = useTranslation()
  return (
    <TButton icon='refresh' loading={isFetching} onClick={refetch} tooltip={t('Refresh')} variant='gray' {...props} />
  )
}
